import type {FC} from 'react';
import {externalLinkToHref} from 'utils';

import type {CallToActionSchema} from 'components/call-to-action/schema';

import {CallToActionDraft} from './draft';
import {CallToActionRender} from './render';
import {CallToActionServer} from './server';

interface Props {
	callToAction: CallToActionSchema;
	isDraft: boolean;
}

export const CallToAction: FC<Props> = ({callToAction, isDraft}) => {
	if (callToAction.type === 'external') {
		return (
			<CallToActionRender
				href={externalLinkToHref(callToAction.href)}
				targetBlank={callToAction.targetBlank}
				text={callToAction.text ?? ''}
				color={callToAction.color ?? 'primary'}
			/>
		);
	}

	if (callToAction.type === 'internal') {
		return isDraft ? (
			<CallToActionDraft callToAction={callToAction} />
		) : (
			<CallToActionServer callToAction={callToAction} />
		);
	}

	return null;
};
